<div class="table-container">
  <ion-row class="main-container">
    <div class="header-container">

      <ion-col *ngIf="!confirmationView && showEditIcon" class="checkbox" size="1">
        <app-form-checkbox  (onChange)="toggleAllCheckBoxes($event,0)" [options]="checkBoxOptions">
        </app-form-checkbox>
        &nbsp;
      </ion-col>


      <ion-col class="header" [ngClass]="{'header-shift': !showEditIcon}" size="2" *ngFor="let item of config">
       {{showRequiredAsterisk && item !== 'Action' ? '* ' : ''}} {{item}}
      </ion-col>
    </div>
  </ion-row>

  <ion-row *ngIf="formGroup" [formGroup]="formGroup">
    <app-edit-recurring-shift-list-item  [class] = "{'create-shift': currentView === 'create-shift'}" [companyType]="companyType" [settings]="settings" class="row-container" *ngFor="let item of data; let i = index"
    (onToggleCheckBox)="toggleCheckBox($event, i)"
    [showSlotActions]="showSlotActions" [canRemoveSlot]="item.canRemove" [canAddSlot]="item.canAdd !== false" [showDate]="item.showDate !== false"
    (addSlot)="addSlot.emit(item.index)" (removeSlot)="removeSlot.emit(item.index)"
     [formArrayName]="formGroupName" [showEditIcon]="showEditIcon" [confirmationView]="confirmationView"  [config]="config" [interfaceCssClass]="interfaceCssClass" [control]="getControl(item.index)"   >
    </app-edit-recurring-shift-list-item>
  </ion-row>
  
  <ion-row *ngIf="!formGroup">
    <app-edit-recurring-shift-list-item [class] = "{'create-shift': currentView === 'create-shift'}" class="row-container" *ngFor="let item of data; let i = index"
     [confirmationView]="confirmationView" [data]="item"  [config]="config" [interfaceCssClass]="interfaceCssClass"  >
    </app-edit-recurring-shift-list-item>
  </ion-row>
</div>